// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import LandingPage from './components/LandingPage/LandingPage';
import About from './components/About/About';
import Catering from './components/Catering/Catering';
import Contact from './components/Contact/Contact';
import Gallery from './components/Gallery/Gallery';
import MenuCategories from './components/MenuCategories/MenuCategories';
import Reviews from './components/Reviews/Reviews';
import Footer from './components/Footer/Footer';
import Menu from './components/Menu/Menu'; 
import Drinks from './components/Drinks/Drinks'
import ScrollToTop from './components/ScrollToTop';
import Socials from './components/Socials/Socials'
import Privacy from './components/Privacy/Privacy'
import Accessibility from './components/Privacy/Accessibility'; 
import AddressBanner from './components/AddressBanner/AddressBanner';
import NotFound from './components/NotFound';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />

<div className="App">
  <Navbar />

  <Socials />

  <Routes>
    <Route path="/" element={
      <>
        <LandingPage />
        <AddressBanner />
        <About />
        <Catering />
        <MenuCategories/>
        <Reviews />
      </>
    } />
    <Route path="/menu" element={<Menu />} />
    <Route path="/drinks" element={<Drinks />} />
    <Route path="/gallery" element={<Gallery />} />
    <Route path="/contact-us" element={<Contact />} />
    <Route path="/accessibility-standards" element={<Accessibility />} />
    <Route path="/terms-and-conditions" element={<Privacy />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
  <Footer />
</div>
</Router>
);
}

export default App;